import React from "react";
import { connect } from "react-redux";
import Description from "src/components/ConditionalRebates/Blocks/Description";
import HandRaisers from "src/components/ConditionalRebates/Blocks/HandRaisers";
import ConditionalRebates from "src/components/ConditionalRebates/Blocks/ConditionalRebates";
import Title from "src/components/ConditionalRebates/Blocks/Title";
import { ApplicationStore } from "src/store";
import { getConditionalRebatesRequest } from "src/store/actions/conditionalRebates";
import "../ConditionalRebates.scss";
import { isConditionalRebatesDataDriven, isConditionalRebatesEnabled } from "src/store/selectors/conditionalRebates";

const PaymentBuilderView = ({
    isEnabled,
    isDataDriven,
    vin,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    if (!isEnabled) {
        return null;
    }

    return (
        <div className={"conditional_rebates_container"}>
            <div className={"conditional_rebates_left"}>
                <Title />
                <Description isDataDriven={isDataDriven} />
            </div>
            <div className={"conditional_rebates-right"}>
                {isDataDriven ? <ConditionalRebates vin={vin} /> : <HandRaisers vin={vin} />}
            </div>
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore) => {
    return {
        vin: state.onlineShopper.toggledVin!,
        isEnabled: isConditionalRebatesEnabled(state),
        isDataDriven: isConditionalRebatesDataDriven(state),
    };
};

const mapDispatchToProps = {
    getConditionalRebates: getConditionalRebatesRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentBuilderView);
